import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import {Product} from '@mintdata-wsp/common/controllers/network/generated/responses/Product';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import bind from 'bind-decorator';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';

const styles = require('./AddonsSelector.less');
const cx = classnames.bind(styles);

@observer
export class AddonsSelector extends React.Component<any, any>
{
    @bind
    _onAddAddon(product:Product)
    {
        return (e:React.SyntheticEvent<any>)=>
        {
            e.stopPropagation();
            e.preventDefault();
            e.nativeEvent.stopImmediatePropagation();

            controllers.ui.productSelection.selectAddon(product);
        };
    }

    @bind
    _onRemoveAddon(product:Product)
    {
        return (e:React.SyntheticEvent<any>)=>
        {
            e.stopPropagation();
            e.preventDefault();
            e.nativeEvent.stopImmediatePropagation();

            controllers.ui.productSelection.deselectAddon(product);
        };
    }

    _onToggleAddon(product:Product)
    {
        return ()=>
        {
            controllers.ui.productSelection.toggleAddonSelection(product);
        };
    }

    render()
    {
        const {storefront} = rootState.data;
        const {addonProducts} = storefront;

        if( !addonProducts )
            return null;

        return <Column className={cx('addonsColumn')}>
                    {
                        addonProducts
                            .map((product:Product)=>
                            {
                                const grant = JSON.parse(product.grant);

                                return <Row key={product.productId}
                                            onClick={this._onAddAddon(product)}
                                            className={cx('addonCardRow')}>

                                            <Column className={cx('addonInfoColumn')}>
                                                <div className={cx('productName')}>
                                                    {product.name}
                                                </div>

                                                <div className={cx('productDescription')}>
                                                    {product.description}
                                                </div>
                                            </Column>
                                            <Column className={cx('ctaColumn')}>
                                                {controllers.ui.productSelection.isAddonSelected(product) ?
                                                    <Row className={cx('ctaSelectedAddonRow')}>
                                                        <WSPButton style={ButtonStyle.SimpleSecondary}
                                                                   className={cx('buttonDeselectAddon')}
                                                                   icon={MDIcons.common.Close}
                                                                   onClick={this._onRemoveAddon(product)}
                                                        />

                                                        <WSPButton className={cx('ctaButton', 'buttonSelectedAddon')}
                                                                   iconClassName={cx('buttonIconSelectedAddon')}
                                                                   // onClick={this._onRemoveAddon(product)}
                                                                   style={ButtonStyle.Simple}
                                                                   intent={MDIntent.Success}
                                                                   icon={MDIcons.common.Checkmark}
                                                                   caption={null}
                                                        />
                                                    </Row>

                                                    :
                                                    <WSPButton className={cx('ctaButton')}
                                                               onClick={this._onAddAddon(product)}
                                                               style={ButtonStyle.Simple}
                                                               icon={null}
                                                               caption={'Add'}/>
                                                }
                                            </Column>
                                    </Row>;
                            })
                    }
                </Column>;
    }
}
